export function ThirdPartyApiList() {
  return [
    {key: 'api-football', value: 'api-football', name: 'API Football'},
    {key: 'api-2', value: 'api-2', name: 'API 2'}
  ]
}

export function ThirdPartyApiFind(value) {
  const list = ThirdPartyApiList()

  const filtered_list = list.filter((item) => item.value === value)

  if (filtered_list.length > 0) {
    return filtered_list[0]
  }

  return null
}

export function ThirdPartyApiNameByValue(value) {
  const thirdPartyApi = ThirdPartyApiFind(value)

  return thirdPartyApi ? thirdPartyApi.name : ""
}
